// src/layouts/UserLayout.jsx
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesAndSubcategories } from "../redux/slices/client/clientHomeSlice";
import UserNavbar from "../components/common/UserNavbar";
import Footer from "../components/common/Footer";
import ChatbotWidget from "../components/chat/ChatbotWidget";

function UserLayout() {
  const dispatch = useDispatch();
const { categories, categoriesFetched } = useSelector((state) => state.home);


  useEffect(() => {
    if (!categoriesFetched && categories.length === 0) {
      dispatch(fetchCategoriesAndSubcategories());
    }
  }, [dispatch, categories, categoriesFetched]);

  return (  
    <div>
      <UserNavbar />
      {/* This is where the child route/page gets rendered */}
      <Outlet />
      <Footer />
      {/* Chatbot will be visible on every page using this layout */}
      <ChatbotWidget />
    </div>
  );
}

export default UserLayout;
